import generateKey from '@rwitl/reformed-util/lib/generateKey'

/**
 * This ensures that every form's last block is an unstyled element. This
 * is to prevent issues in the editor where you can't add whitespace underneath
 * an atomic block if its the last element
 */
function endingUnstyledReducer(screenState, action){

  var newScreenState = Object.assign({}, screenState)

  return processSchema() ? newScreenState : screenState

  function processSchema(){
    return newScreenState['layout'].some(processSomething)
  }

  function processSomething(key){

    var field = newScreenState[key]
    if (field['type'] === 'page')
      return processPage(key)
    else if (field['type'] === 'form'){
      return processForm(key)
    }
  }


  function processForm(formKey){
    var form = newScreenState[formKey]
    if (form['layout'].length == 0) return
    var lastFieldKey = form['layout'][form['layout'].length - 1]
    var field = newScreenState[lastFieldKey]
    if (field.type !== 'unstyled'){
      var newField = {
        'key': generateKey(),
        'type': 'unstyled',
        'text': ' '
      }
      newScreenState[formKey] = Object.assign({}, form)
      newScreenState[formKey]['layout'] = form['layout'].slice(0)
      newScreenState[formKey]['layout'].push(newField['key'])
      newScreenState[newField['key']] = newField
      return true
    }
  }

  function processPage(pageKey){
    var page = newScreenState[pageKey]
    if (page['layout'].length > 0
      && newScreenState[page['layout'][0]]['type'] !== 'form'){
      // If there's fields under the page instead of forms, handle it the same
      // way a form would be handled
      return processForm(pageKey)
    }

    var changed = page['layout'].some(processForm)
    if (changed){
      newScreenState[pageKey] = Object.assign({}, page)
      return true
    }
  }
}

export default endingUnstyledReducer


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/editorReducer/endingUnstyled.js